import React from "react";
import FieldNoteWrap from "./FieldNoteWrap";

function FieldNote() {
  return (
    <section className="bundles-bg section-bottom-pad">
      <FieldNoteWrap />
    </section>
  );
}

export default FieldNote;
